import { Card, Box, Typography } from "@mui/material";
import { useOrgan } from "../../../../hooks/useOrgan";
import { organizationPrimaryColors } from "../../../../layouts/PermanentSidebarMUI";

const EquipmentsList = ({ transferLists }) => {
  const { selectedOrgan } = useOrgan();
  const primaryColor = selectedOrgan?.name
    ? organizationPrimaryColors[selectedOrgan.name.toUpperCase()] ||
      organizationPrimaryColors.ALUCOM
    : organizationPrimaryColors.ALUCOM;

  return (
    <Card>
      {transferLists?.map((transferList, index) => (
        <Box key={index} sx={{ p: 2 }}>
          {/* Título principal */}
          <Typography
            variant="h6"
            color="white"
            textAlign="center"
            sx={{
              fontWeight: 600,
              backgroundColor: primaryColor,
              py: 1,
              px: 3,
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px",
              mb: 2,
              mt: -2,
              mr: -2,
              ml: -2,
            }}>
            {transferList.title}
          </Typography>

          {/* Primeira lista */}
          {transferList?.list && (
            <>
              <Typography
                variant="body2"
                color="white"
                textAlign="center"
                sx={{
                  fontWeight: 600,
                  backgroundColor: "#c7c7c7ff",
                  py: 1,
                  px: 3,
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  mb: 1,
                }}>
                {transferList.list.label}
              </Typography>

              {transferList.list.component}
            </>
          )}

          {/* Segunda lista (SUBSTITUIÇÃO) */}
          {transferList?.list2 && (
            <>
              <Typography
                variant="body2"
                color="white"
                textAlign="center"
                sx={{
                  fontWeight: 600,
                  backgroundColor: "#c7c7c7ff",
                  py: 1,
                  px: 3,
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  mb: 1,
                  mt: 2,
                }}>
                {transferList.list2.label}
              </Typography>

              {transferList.list2.component}
            </>
          )}
        </Box>
      ))}
    </Card>
  );
};

export default EquipmentsList;
